import { StaticImage } from 'gatsby-plugin-image'
import { withTranslation } from 'gatsby-plugin-react-i18next'
import React, { Component } from 'react'
import { logAmplitudeEvent } from '../../../services/amplitude'

import "./Faq.css"

const bear = {
  src: '../../../images/bear/noline.png',
  alt: 'Buxbear saying hi'
}
class Faq extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedCard: ''
    }
  }
  selectCard(id, text) {
    const { selectedCard } = this.state
    if (id === selectedCard) {
      this.setState({ selectedCard: '' })
    } else {
      this.setState({ selectedCard: id }, () => {
        const cardEl = document.querySelector('#hf-selected-content-wrap')
        cardEl &&
          window.scrollBy(0, cardEl.getBoundingClientRect().top - 100)
      })
      logAmplitudeEvent('Clicked on Faq', { question: text })
    }
  }
  render() {
    const { t } = this.props
    const { selectedCard } = this.state
    const selectedCardContent = t(`landing:faq.sections`, { returnObjects: true }).find(el => el.id === selectedCard)
    return (
      <div className="home-faq-wrap">
        <div className="landing-anchor" id="faq" />
        <div className="hf-inner-wrap">
          <h2 className="hf-title">
            <span className="hf-title-dot dot" />
            <span className="hf-head">{t(`landing:faq.head`)}</span>
          </h2>
          <div className={`hf-cards-wrap ${selectedCard ? 'has-selection' : ''}`}>
            <StaticImage 
              className="hf-bear"
              placeholder="none"
              {...bear} 
            />
            {t(`landing:faq.sections`, { returnObjects: true }).map(el => {
              return (
                <button
                  key={el.id}
                  className={`hf-card-wrap${el.id === selectedCard ? ' active': ''}`}
                  onClick={() => this.selectCard(el.id, el.title)}
                >
                  <h3 className="hf-card-title">{el.title}</h3>
                </button>
              )
            })}
          </div>
          <div className="hf-selected-content-wrap" id="hf-selected-content-wrap">
            {selectedCardContent && (
              <div className="hf-selected-card-wrap">
                {selectedCardContent.answer.map((unit, index) => {
                  switch (unit.type) {
                    case 'head':
                      return <p key={index} className="hf-selected-card-head">{unit.content}</p>
                    case 'para':
                      return <p key={index} className="hf-selected-card-para">{unit.content}</p>
                    default:
                      return null
                  }
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}
export default withTranslation(['landing'])(Faq)
